import { render, staticRenderFns } from "./CrearButton.vue?vue&type=template&id=2d625c26&scoped=true&"
import script from "./CrearButton.vue?vue&type=script&lang=ts&"
export * from "./CrearButton.vue?vue&type=script&lang=ts&"
import style0 from "./CrearButton.vue?vue&type=style&index=0&id=2d625c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d625c26",
  null
  
)

export default component.exports